import { componentSizes } from '../../constants/size';
import type { ComponentSize } from '../../constants/size';
import type { DatePickType } from '../../constants/date';
import { datePickTypes } from '../../constants/date';

export const isValidComponentSize = (val: string): val is ComponentSize | '' =>
  ['', ...componentSizes].includes(val);

export const isValidDatePickType = (val: string): val is DatePickType =>
  ([...datePickTypes] as string[]).includes(val);
